import { LocaleId } from '@domgen/dgx-fe-i18n';
import { TranslationDictionaryMapping } from '@domgen/dgx-fe-i18n/lib/models/translation-dictionary/translation-dictionary-mapping.type';
import { CheckoutProgressionStepsTranslationDictionary } from './checkout-progression-steps-translation-dictionary.type';

export const translation: TranslationDictionaryMapping<CheckoutProgressionStepsTranslationDictionary> =
  {
    [LocaleId.English_GreatBritain]: {
      CHECKOUT_PROGRESSION_STEP_CARD: 'Payment',
      CHECKOUT_PROGRESSION_STEP_DIRECT_DEBIT: 'Payment details',
      CHECKOUT_PROGRESSION_STEP_ORDER_CONFIRMATION: 'Confirmation',
      CHECKOUT_PROGRESSION_STEP_PAYMENT_METHOD: 'Payment method',
      CHECKOUT_PROGRESSION_STEP_PERSONAL_DETAILS: 'Your details',
      CHECKOUT_PROGRESSION_STEP_APPLIANCE_DETAILS: 'Your appliance',
    },
    [LocaleId.English_Ireland]: {
      CHECKOUT_PROGRESSION_STEP_CARD: 'Payment',
      CHECKOUT_PROGRESSION_STEP_DIRECT_DEBIT: 'Payment details',
      CHECKOUT_PROGRESSION_STEP_ORDER_CONFIRMATION: 'Confirmation',
      CHECKOUT_PROGRESSION_STEP_PAYMENT_METHOD: 'Payment method',
      CHECKOUT_PROGRESSION_STEP_PERSONAL_DETAILS: 'Your details',
      CHECKOUT_PROGRESSION_STEP_APPLIANCE_DETAILS: 'Your appliance',
    },
    [LocaleId.English_US]: {
      CHECKOUT_PROGRESSION_STEP_CARD: 'Payment',
      CHECKOUT_PROGRESSION_STEP_DIRECT_DEBIT: 'Payment details',
      CHECKOUT_PROGRESSION_STEP_ORDER_CONFIRMATION: 'Confirmation',
      CHECKOUT_PROGRESSION_STEP_PAYMENT_METHOD: 'Payment method',
      CHECKOUT_PROGRESSION_STEP_PERSONAL_DETAILS: 'Your details',
      CHECKOUT_PROGRESSION_STEP_APPLIANCE_DETAILS: 'Your appliance',
    },
  };
